module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "page-on-center rowBackgroundHomepage",
    attrs: {
      "id": "inbox",
      "data-page": "inbox-page",
      "pull-to-refresh": _vm.isSmartphoneOS,
      "infinite-scroll": ""
    },
    on: {
      "ptr:refresh": function($event) {
        return _vm.onRefresh(false)
      },
      "infinite": _vm.onInfinite
    }
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "listPage",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('b-row', {
    staticClass: "form-group justify-content-start showLargeScreenOnly"
  }, [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": _vm.activateSpinner
    },
    on: {
      "click": function($event) {
        return _vm.refreshInbox()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "refresh"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fab-label"
  }, [_vm._v(_vm._s(_vm.$t('common.rfrsh')))])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": _vm.activateSpinner
    },
    on: {
      "click": function($event) {
        return _vm.exportHistory()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "cloud_download"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fab-label"
  }, [_vm._v(_vm._s(_vm.$t('common.exprt')))])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "requestsList"
  }, [_c('div', [_c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isHistory": "",
      "filterType": "list",
      "mode": this.mode,
      "randomId": _vm.randomId
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [(_vm.activateSpinner) ? _c('spinner') : _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "sellersResults"
  }, [_c('thead', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.reOrderBy('dateAction')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.date_label')) + "\n                    "), _c('i', {
    staticClass: "fa",
    class: _vm.dateDirection
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.reOrderBy('typeAction')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.action_type')) + "\n                    "), _c('i', {
    staticClass: "fa",
    class: _vm.actionDirection
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "400px"
    },
    on: {
      "click": function($event) {
        return _vm.reOrderBy('user')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.usr')) + "\n                    "), _c('i', {
    staticClass: "fa",
    class: _vm.userDirection
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "255px"
    },
    on: {
      "click": function($event) {
        return _vm.reOrderBy('endToEndId')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.idtfr')) + "\n                    "), _c('i', {
    staticClass: "fa",
    class: _vm.endToEndIdDirection
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "600px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.dtls')) + "\n                  ")])]), _vm._v(" "), _c('tbody', [(_vm.inboxMessages.length > 0) ? _vm._l((_vm.inboxMessages), function(result) {
    return _c('tr', {
      key: result.idActionHistory,
      staticClass: "boxRequest",
      staticStyle: {
        "cursor": "default"
      },
      on: {
        "click": function($event) {
          return _vm.redirectRTP(result.idObject, result.direction)
        }
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "title": result.dateAction
      }
    }, [_vm._v(_vm._s(result.dateAction))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "title": result.typeAction
      }
    }, [_vm._v(_vm._s(result.typeAction))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "title": result.user
      }
    }, [_vm._v(_vm._s(result.user))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "title": result.endToEndId
      }
    }, [_vm._v(_vm._s(result.endToEndId))]), _vm._v(" "), _c('td', {
      attrs: {
        "title": result.details
      }
    }, _vm._l((result.details.split('. ')), function(line, index) {
      return _c('span', {
        key: index
      }, [(index !== 0) ? _c('br') : _vm._e(), _vm._v(_vm._s(line))])
    }), 0)])
  }) : _c('tr', [_c('td', {
    staticClass: "noResult",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('common.no_result')) + "\n                    ")])])], 2)])])], 1)])])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e2f33d56", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2f33d56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/HistoryPage.vue
// module id = 2517
// module chunks = 2